import { CircularProgress } from '@mui/material';

export const NotificationContentLoading = () => {
  return (
    <div className='flex justify-center items-center py-12'>
      <div className='flex flex-col items-center gap-3'>
        <CircularProgress size={32} color='primary' />
      </div>
    </div>
  );
};
